import React from 'react';
import propTypes from 'prop-types';

/**
 * placeholder tiles shown while the commissions of each month load
 * @param count - how many tiles to render
 */
export default function MonthTilesSkeleton({ count }) {
  return (
    <div className='grid grid-cols-2 gap-2.5 lg:grid-cols-4'>
      {Array.from({ length: count }, (_, i) => (
        <div key={i} className='h-14 animate-pulse rounded-xl bg-grey-lightest' />
      ))}
    </div>
  );
}

MonthTilesSkeleton.propTypes = {
  count: propTypes.number.isRequired
};
